import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, defaultIfEmpty, finalize, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as IotAssetActions from './iotAsset.actions';

import { IotAssetState } from './iotAsset.reducer';
import { selectMappingConfig } from './iotAsset.selector';

import { IotAssetsService } from '../../services/iotAssets.service';

@Injectable()
export class IotAssetEffects {
  loadIotAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IotAssetActions.loadIotAssets),
      switchMap((action) => {
        const { assetType, uidCustomer, uidAssets } = action;
        this.store.dispatch(IotAssetActions.setLoading({ isLoading: true }));

        return this.iotAssetService.getCurrentVehicleStatus(uidAssets).pipe(
          tap(iotAssets => {
            console.log('📊 getCurrentVehicleStatus - risultati:', iotAssets);
          }),
          defaultIfEmpty([]),
          map((iotAssets) => {
            this.store.dispatch(IotAssetActions.setLoading({ isLoading: false }));
            const safeIotAssets = Array.isArray(iotAssets) ? iotAssets : [];
            return IotAssetActions.loadIotAssetsSuccess({ iotAssets: safeIotAssets });
          }),
          catchError((error) => {
            console.error('Errore catturato nell\'effect:', error);
            this.store.dispatch(IotAssetActions.setLoading({ isLoading: false }));
            return of(IotAssetActions.loadIotAssetsFailure({ error }));
          })
        );
      }),
      catchError((outerError) => {
        console.error('Errore esterno non gestito:', outerError);
        this.store.dispatch(IotAssetActions.setLoading({ isLoading: false }));
        return of(IotAssetActions.loadIotAssetsFailure({ error: outerError }));
      })
    )
  );
  refreshIotAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IotAssetActions.refreshIotAssets),
      mergeMap((action) => {
        const { assetType, uidCustomer, uidAssets } = action;
        this.store.dispatch(IotAssetActions.setRefreshing({ isRefreshing: true }));

        return this.iotAssetService.refreshVehicles(assetType, uidCustomer, uidAssets).pipe(
          defaultIfEmpty([]),
          map((iotAssets) => {
            this.store.dispatch(IotAssetActions.setRefreshing({ isRefreshing: false }));
            const safeIotAssets = Array.isArray(iotAssets) ? iotAssets : [];
            return IotAssetActions.refreshIotAssetsSuccess({ iotAssets: safeIotAssets });
          }),
          catchError((error) => {
            console.error('Errore catturato in refreshIotAssets:', error);
            this.store.dispatch(IotAssetActions.setRefreshing({ isRefreshing: false }));
            return of(IotAssetActions.refreshIotAssetsFailure({ error }));
          }),
          finalize(() => {
            this.store.dispatch(IotAssetActions.setRefreshing({ isRefreshing: false }));
          })
        );
      }),
      catchError((outerError) => {
        console.error('Errore esterno non gestito in refreshIotAssets:', outerError);
        this.store.dispatch(IotAssetActions.setRefreshing({ isRefreshing: false }));
        return of(IotAssetActions.refreshIotAssetsFailure({ error: outerError }));
      })
    )
  );

  // Effect per caricare la configurazione di mapping
  loadMappingConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IotAssetActions.loadMappingConfig),
      mergeMap(() =>
        this.iotAssetService.loadMappingConfigForStore().pipe(
          map((mappingConfig) =>
            IotAssetActions.loadMappingConfigSuccess({ mappingConfig })
          ),
          catchError((error) => {
            console.error('Errore nel caricamento della configurazione di mapping:', error);
            return of(IotAssetActions.loadMappingConfigFailure({ error }));
          })
        )
      )
    )
  );

  // Effect per salvare la configurazione di mapping
  saveMappingConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IotAssetActions.saveMappingConfig),
      mergeMap((action) => {
        // La configurazione viene salvata automaticamente dal servizio interno
        // Non serve chiamare saveMappingConfigForStore qui
        console.log('📋 Configurazione mapping aggiornata nello store NgRx');
        return of(IotAssetActions.saveMappingConfigSuccess({ mappingConfig: action.mappingConfig }));
      })
    )
  );

  constructor(private actions$: Actions, private iotAssetService: IotAssetsService, private store: Store<{ iotAssets: IotAssetState }>) {}
}
